import React, { Fragment, useEffect } from "react"
import { compose } from "redux"
import { Divider, Progress, Spin, Tooltip } from "antd"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectIsLoadingEvolutionMeasure,
  makeSelectEvolutionData,
  makeSelectEvolutionLines,
} from "./selectors"
import { getEvolutionMeasureWatcher } from "./actions"

import "./index.less"
import { uuid, validate } from "../../../utils/functions"
import {
  isAmbassadorActive,
  isAmbassadorOrLeaderActive,
  isModuleBySlug,
} from "../../../utils/storage"
import {
  BENCHMARK,
  HISTORICAL_ANALYSIS,
  SURVEY_CALCULATION_TYPE,
  TYPE_SURVEY,
} from "../../../utils/constants"
import { get } from "lodash"
import PopoverBenchmark from "../PopoverBenchmark"
import { ArrowDownIcon } from "../../../icons/svg/iconArrowDown"
import { ArrowUpIcon } from "../../../icons/svg/iconArrowUp"
import { EvolutionLineChart } from "../ReChart/EvolutionLineChart"
import emptyEvolution from "../../../images/empty/evolution.svg"
import { loadImage, loadTexts } from "../../../utils/i18n"

export function WidgetResume(props) {
  const intl = loadTexts("reports_general_view")
  
  useEffect(() => {
    initGetData().then(() => {})
  }, [props.idMeasure, props.idDivisionSelected])

  const initGetData = async () => {
    
    const {
      idMeasure,
      getEvolutionMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureData,
      selectedSegment,
    } = props
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    if (isHistoricalAnalysis) {
      getEvolutionMeasure({
        idMeasure,
        idDivision: idDivisionSelected || idDivisionParent,
        idSegment: selectedSegment,
        id_segment: selectedSegment,
      })
    }
  }

  const renderPieChart = () => {
    const { measureData } = props
    return (
      <div className="pieChart">
        <Tooltip
          overlayClassName="tooltipWhite"
          placement="right"
          title={`${get(measureData, "employees", 0)} ${
            intl.reportAmbassador.engagementMeasurement.widgetResume
              .collaborators
          } `}>
          <Progress
            strokeLinecap="square"
            width={112}
            height={112}
            format={() => get(measureData, "value_visible", "n/a")}
            strokeWidth={9}
            strokeColor={get(measureData, "color", "black")}
            type="circle"
            id={`WidgetResume_${uuid()}`}
            percent={parseInt(get(measureData, "percent", "n/a"))}
          />
        </Tooltip>
      </div>
    )
  }

  const renderComparisonResultAgainstOrganization = () => {
    const { measureData, measureGeneral } = props

    let isEngagement = measureGeneral.is_engagement
    let organizationKey = props.selectedSegment ? "engagement_org_general" : "engagement_org"

    const resultOrgRight =
      get(measureData, "percent", 0) -
      (isEngagement
        ? get(measureData, organizationKey, 0)
        : get(measureData, "value_org", 0))

    return (
      isAmbassadorOrLeaderActive() && (
        <div className="WidgetResumeComponent-body-chart-org">
          <div className="WidgetResumeComponent-body-chart-org-title">
            {
              intl.reportAmbassador.engagementMeasurement.widgetResume
                .organization
            }
          </div>
          <div className="WidgetResumeComponent-body-chart-org-content">
            <span>
              {isEngagement
                ? `${get(measureData, organizationKey, 0)}%`
                : `${get(measureData, "value_org", 0)}%`}
            </span>

            <div>
              <span>
                {resultOrgRight !== 1 ? ~~resultOrgRight : resultOrgRight}%
              </span>
              {resultOrgRight !== 1 &&
                (~~resultOrgRight > 0 ? (
                  <ArrowUpIcon style={{ marginLeft: 2 }} />
                ) : ~~resultOrgRight !== 0 ? (
                  <ArrowDownIcon style={{ marginLeft: 2 }} />
                ) : null)}
            </div>
          </div>
        </div>
      )
    )
  }

  const renderComparative = () => {
    const { measureData, measureGeneral } = props
    const { calculate_comparative, benchmark } = measureData
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (
      !validate.exist(calculate_comparative) ||
      validate.empty(calculate_comparative) ||
      !calculate_comparative.show ||
      !isHistoricalAnalysis ||
      get(measureGeneral, 'id_measure_type', 1) === 2
    ) {
      return null
    }

    const surveyType = get(measureGeneral, "id_survey_type", null)
    let isBenchmarkRender = true
    if (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()) {
      isBenchmarkRender = false
    }
    if (!validate.exist(benchmark) || !benchmark.show || !isBenchmark) {
      isBenchmarkRender = false
    }

    if (surveyType === TYPE_SURVEY.leadership.idSurveyType) {
      isBenchmarkRender = false
    }

    return (
      <div
        className={`WidgetResumeComponent-body-footer-comparative ${
          isBenchmarkRender ? "benchmark" : ""
        }`}>
        <div className="WidgetResumeComponent-body-footer-comparative-title">
          {
            intl.reportAmbassador.engagementMeasurement.widgetResume
              .previousMeasure
          }
        </div>
        <div className="WidgetResumeComponent-body-footer-comparative-value">
          <div className="WidgetResumeComponent-body-footer-comparative-value-current">
            {measureGeneral.id_survey_calculation_type == 1
              ? `${Math.round(calculate_comparative.prev_value)}%`
              : `${calculate_comparative.prev_value}`}
          </div>
          <div
            className={`WidgetResumeComponent-body-footer-comparative-value-comparative ${
              calculate_comparative.level === true
                ? " green"
                : calculate_comparative.level === false
                ? " red"
                : ""
            }`}>
            <div>{calculate_comparative.value}</div>
            {calculate_comparative.level === true ? (
              <ArrowUpIcon style={{ marginLeft: 2 }} />
            ) : calculate_comparative.level === false ? (
              <ArrowDownIcon style={{ marginLeft: 2 }} />
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  const renderBenchmark = () => {
    const { measureData, measureGeneral } = props
    const surveyType = get(measureGeneral, "id_survey_type", null)
    if (surveyType === TYPE_SURVEY.leadership.idSurveyType) {
      return null
    }
    const { benchmark } = measureData
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()) {
      return null
    }
    if (!validate.exist(benchmark) || !benchmark.show || !isBenchmark) {
      return null
    }
    return (
      <div className="WidgetResumeComponent-body-footer-benchmark">
        <div className="WidgetResumeComponent-body-footer-benchmark-title">
          <PopoverBenchmark
            isGlobalBenchmark={measureGeneral.is_global_benchmark}
          />
        </div>
        <div className="WidgetResumeComponent-body-footer-benchmark-value">
          <div className="WidgetResumeComponent-body-footer-benchmark-value-current">
            {benchmark.value}
          </div>
          <div
            className={`WidgetResumeComponent-body-footer-benchmark-value-comparative ${
              benchmark.level === true
                ? " green"
                : benchmark.level === false
                ? " red"
                : ""
            }`}>
            <div>{`${benchmark.variation}%`}</div>
            {benchmark.level === true ? (
              <ArrowUpIcon style={{ marginLeft: 2 }} />
            ) : benchmark.level === false ? (
              <ArrowDownIcon style={{ marginLeft: 2 }} />
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  const renderFooter = () => {
    const { measureData, measureGeneral } = props
    // const { calculate_comparative, benchmark } = measureData
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    const isBenchmark = isModuleBySlug(BENCHMARK)
    let isComparativeRender = true
    if (
      (measureData &&
        (!validate.exist(measureData.calculate_comparative) ||
          validate.empty(measureData.calculate_comparative) ||
          !measureData.calculate_comparative.show)) ||
      !isHistoricalAnalysis
    ) {
      isComparativeRender = false
    }
    let isBenchmarkRender = true
    if (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()) {
      isBenchmarkRender = false
    }
    if (
      (measureData &&
        (!validate.exist(measureData.benchmark) ||
          !measureData.benchmark.show)) ||
      !isBenchmark
    ) {
      isBenchmarkRender = false
    }
    if (!isComparativeRender && !isBenchmarkRender) {
      return null
    }
    return (
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div className="WidgetResumeComponent-body-footer">
          {measureData && renderComparative()}
          {measureData && renderBenchmark()}
        </div>
      </div>
    )
  }

  const renderContent = () => {
    const { title } = props
    return (
      <div className="WidgetResumeComponent">
        <div className="WidgetResumeComponent-header">{title}</div>
        <div className="WidgetResumeComponent-body">
          <div className="WidgetResumeComponent-body-chart">
            {renderPieChart()}
            {renderComparisonResultAgainstOrganization()}
          </div>
          {renderFooter()}
        </div>
      </div>
    )
  }

  const renderContentEvolution = () => {
    const { evolutionData, evolutionLines, measureGeneral } = props
    if (measureGeneral.id_measure_type === 2 || !Array.isArray(evolutionData)) {
      return null
    }

    const isCalculationTopTwoBox =
      measureGeneral.id_survey_calculation_type ===
      SURVEY_CALCULATION_TYPE.topTwoBox

    // const title = isCalculationTopTwoBox ? "Evolución" : "Tendencia"

    const title =
      intl.reportAmbassador.engagementMeasurement.widgetResume.evolutionTitle
    const evolutionImage =
      intl.reportAmbassador.engagementMeasurement.widgetResume
        .urlEvolutionEmptyImage

    return (
      <Fragment>
        <Divider style={{ height: "100%", margin: "0 16px" }} type="vertical" />
        <div className="ContentEvolution">
          <div className="ContentEvolution-Title">{title}</div>
          <div className="ContentEvolution-Chart">
            {evolutionData.length < 2 ? (
              <img
                className="ContentEvolution-Chart-Empty"
                src={loadImage(evolutionImage)}
              />
            ) : (
              <EvolutionLineChart
                data={evolutionData}
                lines={evolutionLines}
                isCalculationTopTwoBox={isCalculationTopTwoBox}
              />
            )}
          </div>
        </div>
      </Fragment>
    )
  }

  if (props.isLoadingEvolutionMeasure) {
    return (
      <div className={props.className} style={{ width: "100%" }}>
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      </div>
    )
  }

  return (
    <div
      className={props.className}
      style={
        props.measureGeneral.id_measure_type === 1 &&
        Array.isArray(props.evolutionData)
          ? { width: "100%" }
          : {}
      }>
      {renderContent()}
      {props.showContentEvolution && renderContentEvolution()}
    </div>
  )
}

WidgetResume.propTypes = {
  measureGeneral: PropTypes.object,
  showHistoryWidget: PropTypes.bool,
  className: PropTypes.string,
  measureData: PropTypes.object,
  isLeadership: PropTypes.bool,
  title: PropTypes.object,
  withEmpty: PropTypes.bool,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  idMeasure: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  evolutionData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  evolutionLines: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isLoadingEvolutionMeasure: PropTypes.bool,
  selectedSegment: PropTypes.number,
  showContentEvolution: PropTypes.bool,
  isEngagement: PropTypes.bool
}

WidgetResume.defaultProps = {
  showContentEvolution: true,
}

const mapStateToProps = createStructuredSelector({
  isLoadingEvolutionMeasure: makeSelectIsLoadingEvolutionMeasure(),
  evolutionData: makeSelectEvolutionData(),
  evolutionLines: makeSelectEvolutionLines(),
})

function mapDispatchToProps(dispatch) {
  return {
    getEvolutionMeasure: (params) =>
      dispatch(getEvolutionMeasureWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "widgetResume", reducer })
const withSaga = injectSaga({ key: "widgetResume", saga })

export default compose(withReducer, withSaga, withConnect)(WidgetResume)
